<template>
    <span v-if="!!paymentMethod">
        {{ paymentMethod.value }}
    </span>
</template>

<script>
    import {paymentMethods} from '@/constants/payment-constants';

    export default {
        name: "PaymentMethodName",
        props: {
            value: String
        },
        data: function () {
            return {
                paymentMethod: !!this.value ? this.findOptionByKey(this.value) : null
            }
        },
        methods: {
            findOptionByKey(key) {
                return paymentMethods.find(method => (method.key === key));
            }
        },
        watch: {
            value: function () {
                if (!!this.value) {
                    this.paymentMethod = this.findOptionByKey(this.value);
                }
            }
        }
    }
</script>

<style scoped>

</style>